import React from "react";
import { Button } from "components/common/Button";
import { Callout } from "components/common/Callout";
import { formatDayMonth } from "@/lib/dates";
import type { PaymentStanding } from "@/lib/api/organizations";

export const StandingNotice: React.FC<{
  standing: PaymentStanding;
  onUpdateCard?: () => void;
}> = ({ standing, onUpdateCard }) => {
  if (standing.state === "current") return null;

  const action = onUpdateCard && (
    <span className="mt-1 block">
      <Button
        variant="secondary"
        size="sm"
        onClick={onUpdateCard}
        data-testid="update-payment-method"
      >
        Update payment method
      </Button>
    </span>
  );

  if (standing.state === "grace") {
    return (
      <Callout variant="warning" title="Payment failed" className="mx-2">
        {`Update your card before ${formatDayMonth(standing.read_only_on * 1000)} ` +
          `to keep adding data and members.`}
        {action}
      </Callout>
    );
  }

  // The day number is ladder jargon; the date is what someone can act on.
  return (
    <Callout
      variant="error"
      title="Read-only — payment overdue"
      className="mx-2"
    >
      {`Adding data and members is paused until payment goes through — the plan ` +
        `lapses on ${formatDayMonth(standing.revoke_on * 1000)}. Reads and ` +
        `exports still work.`}
      {action}
    </Callout>
  );
};
